/** Definición declarativa de navegación (fuente única para sidebar y router). */
export interface NavItem {
  path: string
  label: string
  /** Glifo simple (sin dependencias de iconos) para el shell. */
  icon: string
  end?: boolean
}

export const NAV_ITEMS: NavItem[] = [
  { path: '/', label: 'Inicio', icon: '◆', end: true },
  { path: '/analyze', label: 'Analizar Empresa', icon: '⌕' },
  { path: '/history', label: 'Historial', icon: '≣' },
  { path: '/settings', label: 'Configuración', icon: '⚙' },
]
